import { InjectionToken } from '@angular/core'

export const TranslationsPrefix = new InjectionToken('TranslationsPrefix')
export const TranslationsLanguages = new InjectionToken('TranslationsLanguages')
